export function filterArray(array, filter) {
    return array.filter(role => !filter || role.roleName.toUpperCase().includes(filter.toUpperCase()));
  }
  